export const getAudioFormat = (audioFilePath: string) => {
    return 'audio/' + audioFilePath.slice(-3);
};
